import { Route, Routes as ReactRoutes, Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import Dashboard from './Dashboard/Dashboard';
import Header from '../components/common/Header';
import ScrollToTop from '../components/common/ScrollToTop';
import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy';
import TermsAndCondition from './TermsAndConditions/TermsAndCondition';
import RefundPolicy from './RefundPolicy/RefundPolicy';
import UserRole from './RoleAndUser/User/UserRole';
import RoleAndUserManagment from './RoleAndUser/Role/RoleAndUserManagment';
import PodcasterManagement from './PodcastersManagement/PodcastersManagement';
import CategoryTreeManagement from "./CategoryManagement/Index";
import ReportsPage from './ReportsPage';
import PermissionManagement from './RoleAndUser/Permission/PermissionManagement';
import CustomerList from "./CustomersManagement/CustomerList";
import InternalAudioAdsManagement from "./InternalAudioAds/Index";
import VipBannersManagement from "./VipBanners/Index";
import EmailNotifications from "./Notifications/EmailNotifications/Index";
import PushNotificationManagement from "./Notifications/PushNotifications/Index";
import CampaignManagement from "./Notifications/CampaignManagement/Index";
import NotificationCampaigns from "./Notifications/NotificationCampaigns/Index";
import NotificationsInbox from "./Notifications/Inbox/Index";

// Auth Screens
import Login from './Auth/Login';
import ForgotPassword from './Auth/ForgotPassword';
import ResetPassword from './Auth/ResetPassword';
import ProtectedRoute from '../components/common/ProtectedRoute';
import ContactSettings from './Settings/ContactSettings';
import GoogleAdMobSettings from "./Settings/GoogleAdMobSettings";
import Profile from './Profile/Profile';
import AlbumManagement from './AlbumManagement/AlbumList';
import AudioLibrary from './AudioLibrary/AudioLibrary';
import SubscriptionsManagement from './SubscriptionsManagement/SubscriptionsList';
import SubscriptionsHistoryManagement from "./SubscriptionsManagement/SubscriptionHistoryList";
import TransactionsListManagement from "./SubscriptionsManagement/TransactionsList";
import AlbumDetails from "./AlbumManagement/AlbumDetails";
import AlbumPublishRequestsManagement from "./AlbumManagement/PublishRequests";
import TracksPublishRequestsManagement from "./AlbumManagement/TracksPublishRequests";
import ContentReportsPage from "./ContentReport/Index";

// payment callback
import PaymentCallbackPage from "./PaymentCallback/Index";

export const allRoutes = [
    // === Dashboard ===
    { path: "/dashboard", Component: Dashboard },

    // === Profile ===
    { path: "/profile", Component: Profile },

    // === User Management ===
    { path: '/administrators', Component: UserRole },

    // === Role Management ===
    { path: '/permission-management', Component: PermissionManagement },
    { path: '/role-management', Component: RoleAndUserManagment },
    // { path: '/roles-management/add', Component: AddRole },
    // { path: '/role-edit/:id', Component: AddRole },

    // === Podcasters Management ===
    { path: '/podcasters', Component: PodcasterManagement },
    
    
    
    { path: '/categories', Component: CategoryTreeManagement },
    
    { path: '/subscriptions', Component: SubscriptionsManagement },
    { path: '/subscriptions/history', Component: SubscriptionsHistoryManagement },
    { path: '/subscriptions/transactions', Component: TransactionsListManagement },
    
    
    // === Customers Management ===
    { path: '/customers', Component: CustomerList },
    
    // album managemnet 
    { path: '/albums', Component: AlbumManagement },
    { path: '/albums/:albumSlug', Component: AlbumDetails }, // when dynamic used this 
    { path: '/albums/publish-requests', Component: AlbumPublishRequestsManagement },
    { path: '/albums/tracks/publish-requests', Component: TracksPublishRequestsManagement },
    // audio managemnet 
    { path: '/audio-library', Component: AudioLibrary },
    // === Reports ===
    { path: '/reports', Component: ReportsPage },

    { path: '/content-reports', Component: ContentReportsPage },

    { path: '/advertising/internal-audio-ads', Component: InternalAudioAdsManagement },
    { path: '/advertising/vip-banners', Component: VipBannersManagement },
    
    // notifications
    { path: '/notifications/email-notifications', Component: EmailNotifications },
    { path: '/notifications/push-notifications', Component: PushNotificationManagement },
    { path: '/notifications/campaigns-management', Component: CampaignManagement },
    { path: '/notifications/campaigns-notifications', Component: NotificationCampaigns },
    { path: '/notifications', Component: NotificationsInbox },

    // === Policies ===
    { path: '/privacy-policy', Component: PrivacyPolicy },
    { path: '/terms-conditions', Component: TermsAndCondition },
    { path: '/about_us', Component: RefundPolicy },
    { path: '/contact-settings', Component: ContactSettings },
    { path: '/google-admob-settings', Component: GoogleAdMobSettings },
];

export const publicRoutes = [
    { path: '/sign-in', Component: Login },
    { path: '/forgot-password', Component: ForgotPassword },
    { path: '/reset-password', Component: ResetPassword },
    { path: '/payment/callback', Component: PaymentCallbackPage },
];


function MainIndex(props) {
    const { activekey } = props;
    
    const { token: reduxToken } = useSelector((state) => state.AuthReducer );
    
    const token = reduxToken || sessionStorage.getItem('admin-token');
    
    const defaultRedirect = token
        ? `${process.env.PUBLIC_URL}/dashboard`
        : `${process.env.PUBLIC_URL}/sign-in`;

    return (
        <div className='main'>
            {/* Header logic moved or handled by route presence */}
            <ReactRoutes>
                {publicRoutes.map(({ path, Component }) => (
                    <Route
                        key={path}
                        path={process.env.PUBLIC_URL + path}
                        element={<Component />}
                    />
                ))}
                {allRoutes.map(({ path, Component }) => (
                    <Route
                        key={path}
                        path={process.env.PUBLIC_URL + path}
                        element={
                            <ProtectedRoute>
                                <div className="w-100">
                                    <Header />
                                    <div className="">
                                        <Component />
                                    </div>
                                </div>
                            </ProtectedRoute>
                        }
                    />
                ))}

                <Route path={process.env.PUBLIC_URL + "/"} element={<Navigate to={defaultRedirect} />} />
                <Route path="*" element={<Navigate to={defaultRedirect} />} />
            </ReactRoutes>
            <ScrollToTop />
        </div>
    );
}

export default MainIndex;
